import TableRow from "@component/common/TableRow";
import TableText from "@component/common/TableText";
import { BANNER_INFO } from "@constant/BANNER_INFO";
import BannerPopper from "./BannerPopper";
import { BannerEntity } from "@entity/banner.entity";

interface BannerValueProps {
  banner: BannerEntity;
}

export default function BannerValue({ banner }: BannerValueProps) {
  return (
    <TableRow
      children={BANNER_INFO.map(({ COLUMN, WIDTH }) => (
        <TableText key={COLUMN} width={WIDTH}>
          {findBannerValue(banner, COLUMN)}
        </TableText>
      ))}
      popper={<BannerPopper banner={banner} />}
    />
  );
}

function findBannerValue(banner: BannerEntity, column: string) {
  switch (column) {
    case "순번":
      return banner.order;
    case "제목":
      return banner.title;
    case "연결된 공지사항":
      // 게시글 제목은 목록 응답에 없어 연결 여부만 표시한다
      return banner.noticePostId ? "연결됨" : "-";
    default:
      return "";
  }
}
